export enum MyDSpaceConfigurationValueType {
  Workspace = 'workspace',
  Workflow = 'workflow'
}
